
import React from "react";
import Box from '@mui/material/Box';
import CampaignBriefChat from "./CampaignBriefChat";
import classes from "./CampaignBrief.module.scss";

const CampaignBrief = () => {

  return (
    <>
      <Box component="section" className={classes.chatGridExpanded}>
        <div className={classes.headline}>
          <h3 className={classes.title}>Campaign Brief</h3>
        </div>
        <CampaignBriefChat ></CampaignBriefChat>
      </Box>
    </>
  );

}
export default CampaignBrief;
